import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { CloudItem } from 'reactApp/modules/storage/storage.types';
import { mapKindToName, mapSubKindToName } from 'reactApp/types/Tree';

import type { PublicInfoModalPorps } from './PublicInfoModal.types';

export const renderPublicInfoModal = (data: PublicInfoModalPorps) => openPopupHelper({ popupName: popupNames.PUBLIC_INFO, data });

export const getPublicItemType = (item?: CloudItem) => {
    const kind = item?.kind;
    const subKind = item && 'subKind' in item && item?.subKind;

    if (item?.isFolder && item?.kind !== 'album') {
        return 'Папка';
    }

    if (subKind && mapSubKindToName?.[subKind]) {
        return mapSubKindToName[subKind];
    }

    if (kind && mapKindToName?.[kind]) {
        return mapKindToName[kind];
    }

    return 'Файл';
};
